export default __webpack_public_path__ + "locales/si/Webhooks.json?hash=742441608201a1eece7a06e28418e23c";